<template>
    <div class="pBox">
        <div class="form-box">
            <div class="left">
                <form class="form-horizontal">
                  
                    <div class="familyInfo">
                      
                        <div v-for="(item,index) in familylist" :key="index" v-if="familylist">
                          <h4>家属有关信息</h4>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">姓名 <i>*</i> </label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control"  placeholder="姓名" v-model="item.xm">
                                </div>
                            </div>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">关系 <i>*</i> </label>
                                <div class="col-sm-9 realship">
                                    <span v-for="(value,index) in label" :key="index"  @click="choose(item,value)">
                                        <i :class="{choose:value.name == item.relationship}" class="tb"></i>{{value.name}}
                                    </span>
                                </div>
                            </div>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">年龄  </label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control"  placeholder="请填写年龄（周岁）" v-model="item.age">
                                </div>
                            </div>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">联系方式  </label>
                                <div class="col-sm-9">
                                    <input type="number" class="form-control"  placeholder="联系方式" v-model="item.mobile">
                                </div>
                            </div>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">工作  </label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control"  placeholder="工作" v-model="item.work">
                                </div>
                            </div>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">年收入  </label>
                                <div class="col-sm-9">
                                    <input type="number"  class="form-control"  placeholder="请填写年收入（元）" v-model="item.income">
                                </div>
                            </div>
                            <div class="form-group">
                                <label  class="col-sm-3 control-label">健康  </label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control"  placeholder="请填写健康情况" v-model="item.health">
                                </div>
                            </div>
                            <p class="fr TB">
                                <button type="button" class="btn btn-default btn-sm"  @click="minus(index)">
                                    <span class="glyphicon glyphicon-minus"></span> 删除
                                </button>
                            </p>
                        </div>
                    </div>
                    <h4>家庭有关信息</h4>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">家庭收入</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control"  placeholder="家庭收入" v-model="data.year_income">
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">资助情况</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" placeholder="学生本年已获取资助情况" v-model="data.funding_situation"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">意外事件</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" placeholder="家庭遭受突发意外事件" v-model="data.accident"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">失业详情</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" placeholder="家庭成员失业情况" v-model="data.unemployment"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">家庭欠债</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" placeholder="家庭欠债及原因" v-model="data.debt_situation"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">其他情况 </label>
                        <div class="col-sm-9">
                            <textarea class="form-control" placeholder="视情况填写" v-model="data.other_situation"></textarea>
                        </div>
                    </div>
                    
                </form>
                <div class="btn-box">
                    <button type="button" class="btn btn-default btn-lg" @click="addFamily">添加</button>
                    <button type="button" class="btn btn-success btn-lg" data-toggle="modal" data-target="#myModal">提交</button>
                </div>
            </div>
        </div>
         <page-load v-if="flag"></page-load>
        <!-- 提示框   -->
        <tip :tip="tip" v-show="tipShow"></tip>
        <!-- 模态框1 -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
	        <div class="modal-dialog">
		        <div class="modal-content">
			        <div class="modal-header">
				        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        &times;
				        </button>
				        <h4 class="modal-title" id="myModalLabel">
                        提示框
				        </h4>
			        </div>
                    <h4 class="modal-body">
				        确定提交吗
			        </h4>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">关闭
                        </button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="_submit">
                            提交更改
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 模态框2-->
        <div class="modal fade" id="myModal_l" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
	        <div class="modal-dialog">
		        <div class="modal-content">
			        <div class="modal-header">
				        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        &times;
				        </button>
				        <h4 class="modal-title" id="myModalLabel">
                        提示框
				        </h4>
			        </div>
                    <h4 class="modal-body">
				        确定删除吗
			        </h4>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">关闭
                        </button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="minus(index)">
                            提交更改
                        </button>
                    </div>
                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
import { getFamilyInfo, updataFamilyInfo } from "@/api/login.js";
import pageLoad from "../pageload/pageload";
let Base64 = require("js-base64").Base64;

export default {
  components: { pageLoad },
  data() {
    return {
      familylist: [], //家属信息集合
      data: {}, //家庭信息结合
      label: [{ name: "父亲" }, { name: "母亲" }, { name: "其他" }],
      tipShow: false, //tip提示
      tip: "", //tip提示信息
      index: 0,
      flag: true
    };
  },
  created() {
    this._getFamilyInfo();
  },
  methods: {
    //切换删除下标
    changeIndex(item) {
      this.index = item;
    },
    //提示框方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    },
    //修改家属信息
    _updataFamilyInfo() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        xs_sfzjh: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        sch_id: JSON.parse(sessionStorage.getItem("stuInfo")).sch_id,
        parent: this.familylist,
        year_income: this.data.year_income,
        unemployment: this.data.unemployment,
        other_situation: this.data.other_situation,
        funding_situation: this.data.funding_situation,
        debt_situation: this.data.debt_situation,
        accident: this.data.accident
      };
      updataFamilyInfo(module)
        .then(res => {
          this.flag = false;
          if (res.status) {
            this.tipCtr(res.msg);
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.flag = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //添加家属信息
    addFamily() {
      var family = {
        xm: "",
        relationship: "",
        mobile: "",
        work: "",
        age: "",
        health: "",
        income: ""
      };
      this.familylist.push(family);
    },
    //删除
    minus(index) {
      this.familylist.splice(index, 1);
    },
    //获取家属信息
    _getFamilyInfo() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      this.flag = true;
      getFamilyInfo(module)
        .then(res => {
          this.flag = false;
          if (res.status && res.data && res.familyInfo) {
            this.familylist = res.data;
            this.data = res.familyInfo;
          } else {
            // this.data = {
            //   year_income: "",
            //   funding_situation: "",
            //   accident: "",
            //   unemployment: "",
            //   debt_situation: "",
            //   other_situation: ""
            // };
            // this.familylist = [
            //   {
            //     xm: "",
            //     relationship: "",
            //     age: "",
            //     mobile: "",
            //     work: "",
            //     income: "",
            //     health: ""
            //   }
            // ];
          }
        })
        .catch(err => {
          this.flag = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提交修改
    _submit() {
      this.flag = true;
      this._updataFamilyInfo();
    },
    choose(item, value) {
      this.$set(item, "relationship", value.name);
    }
  }
};
</script>
<style scoped>
.left {
  width: 70%;
  padding: 30px 0;
  margin: 0 auto;
}
.form-horizontal h4 {
  padding: 5px 10px;
  margin-bottom: 20px;
  font-weight: bold;
  color: #333;
  border-left: 5px solid deepskyblue;
}
.realship i.tb {
  width: 20px;
  height: 20px;
  margin: -2px 5px 0 0 !important;
  vertical-align: middle;
  cursor: pointer;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  outline: none;
  border-radius: 100%;
}
.realship {
  height: 40px;
  line-height: 40px;
}
.realship > span {
  margin-right: 15px;
  font-size: 14px;
}
.choose {
  background: #ff9000 !important;
  border: none !important;
}
.familyInfo > div {
  margin-bottom: 20px;
}
.familyInfo > div:not(:first-child) {
  margin-top: 80px;
}
.form-horizontal i {
  color: red;
  font-size: 16px;
  display: inline-block;
  margin-right: -10px;
}
textarea {
  min-height: 55px;
}
/***input 间距***/
form > div:last-child {
  margin-bottom: 0 !important;
}
.form-horizontal .form-group {
  margin: 0 0 20px;
}
/***input lable文字***/
.form-horizontal .control-label {
  padding-top: 8px;
  color: #333;
  font-size: 15px;
}
.radio-lable {
  padding-top: 9px;
  margin-right: 40px;
  cursor: pointer;
}
/***input***/
.form-control {
  height: 40px;
  color: #333;
  font-size: 14px;
}
.btn-box button {
  min-width: 120px;
}
.btn-box button:first-child {
  margin: 20px 0 20px 183px;
}
.btn-box button:last-child {
  margin: 20px 0 20px 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/familyInfo.vue